<section class="p-b-16">
  <div class="m-t-16 no print flex flex-row gap-2">
    <button type="button" mat-stroked-button color="primary" (click)="pdf.saveAs('Original_Manufacturer_License.pdf')">
      Export to PDF
    </button>

    <button type="button" mat-stroked-button color="warn" (click)="cancel()">Close</button>
  </div>
</section>
<mat-dialog-content>
  <kendo-pdf-export #pdf
                    paperSize="letter"
                    [scale]="0.75"
                    margin="1cm"
                    keepTogether="span">
    <div id="certificate" #certificate class="f-s-16 flex flex-col gap-2">
      <div class="flex flex-row gap-2">
        <div class="flex flex-col flex-1">
          <span class="f-s-18"><strong>PUBLIC HEALTH DIVISION</strong></span>
          <span class="f-s-18"><strong>CENTER FOR HEALTH PROTECTION</strong></span>
          <span><strong>Oregon Psilocybin Services</strong></span>
          <span><a href="http://oregon.gov/psilocybin">http://oregon.gov/psilocybin</a></span>
        </div>
        <img class="p-4" src="../../../../../assets/images/OHA-Color-Small.png" alt="OHA Logo">
      </div>

      <mat-card>
        <mat-card-title>
          <div class="flex flex-row justify-start items-center gap-4">
            <span>Manufacturer</span>
            <span class="f-s-18">{{license.licenseId}}</span>
            <span class="flex-1"></span>
          </div>
        </mat-card-title>

        <mat-card-content>
          <div class="flex flex-row gap-4">
            <mat-card class="w-[50%]">
              <mat-card-title>
                <span>Manufacturer Information</span>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <span class="f-s-16"><strong>Manufacturer Operational Name</strong></span>
                  <span>{{license.entityName}}</span>

                  <span class="f-s-16"><strong>Manufacturer Website</strong></span>
                  <span>{{license.entityWebsite}}</span>

                  <span class="f-s-16"><strong>Registered Business</strong></span>
                  <div class="flex flex-row">
                    <mat-checkbox [checked]="license.businessInOregon" disabled>
                      <span class="text-wrap">This legal entity is registered as a business with the Secretary of State (SOS) in Oregon</span>
                    </mat-checkbox>
                  </div>
                  <div *ngIf="license.businessInOregon" [@slideInOut] class="flex flex-col gap-2">
                    <div class="flex flex-col">
                      <span>Oregon Secretary of State Registry Number</span>
                      <span>{{license.secretaryofStateNumber}}</span>
                    </div>
                  </div>

                  <div class="flex flex-row">
                    <mat-checkbox [checked]="license.registeredBusiness" disabled>
                      <span class="text-wrap">This legal entity is registered as a business in another state, US territory or a freely associated state</span>
                    </mat-checkbox>
                  </div>
                  <div *ngIf="license.registeredBusiness" [@slideInOut] class="flex flex-col gap-2">
                    <div class="flex flex-col">
                      <span>Location Registered</span>
                      <span>{{license.registeredIn}}</span>
                    </div>
                    <div class="flex flex-col">
                      <span>Registration Number</span>
                      <span>{{license.registryNumber}}</span>
                    </div>
                  </div>

                  <span class="f-s-16"><strong>Previous License or Permit</strong></span>
                  <mat-checkbox [checked]="license.previousLicense" disabled>
                    <span class="text-wrap">Manufacturer has applied for or received any other Oregon Psilocybin licenses</span>
                  </mat-checkbox>
                  <div *ngIf="license.previousLicense" [@slideInOut] class="flex flex-col">
                    <span>{{license.affiliatedLicenses}}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <div class="flex flex-col w-[50%]">
              <div class="flex flex-row w-[100%]">
                <mat-card>
                  <mat-card-title>
                    <span>Primary Point of Contact</span>
                  </mat-card-title>
                  <mat-card-content>
                    <div class="flex flex-col gap-4">
                      <div class="flex flex-col">
                        <span class="f-s-16"><strong>Contact Name</strong></span>
                        <span>{{license.primaryContactName}}</span>
                      </div>
                      <div class="flex flex-col">
                        <span class="f-s-16"><strong>Contact Phone</strong></span>
                        <span>{{license.primaryContactNumber | mask: '(000) 000-0000 000000'}}</span>
                      </div>
                      <div class="flex flex-col">
                        <span class="f-s-16"><strong>Email Address</strong></span>
                        <span>{{license.primaryContactEmail}}</span>
                      </div>
                      <div class="flex flex-col">
                        <span class="f-s-16"><strong>Preferred Language</strong></span>
                        <span>{{license.language}}</span>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>

<!--Account Information-->
          <div class="flex flex-row gap-4">
            <mat-card class="w-[50%]">
                <div class="flex flex-col gap-2">
                  <div class="flex flex-row w-[100%]">
                      <mat-card-title>
                        <span>Account Information</span>
                      </mat-card-title>
                  </div>
                  <div class="flex flex-row w-[100%]">
                    <mat-card-content>
                      <div class="flex flex-col gap-2">
                        <span><strong>Account Name</strong></span>
                          <span>{{license.accountName}} </span>
                          <span><strong>Account Email</strong></span>
                          <span>{{license.accountEmail}} </span>
                      </div>
                    </mat-card-content>
                  </div>
                </div>
            </mat-card>
          </div>

<!-- Endorsements & Address-->
          <div class="flex flex-row gap-4">
            <mat-card class="w-[50%]">
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <div class="flex flex-row w-[100%]">
                    <mat-card class="w-[100%]">
                      <mat-card-title>
                        <span>Endorsements and Attestations</span>
                      </mat-card-title>
                      <mat-card-content>
                        <div class="flex flex-col gap-2">
                          <span class="f-s-16">
                            <strong>Endorsements requested</strong>
                          </span>

                          <div class="flex flex-col gap-2">
                            <mat-checkbox [checked]="license.fungiCultivation" disabled>
                              <span class="text-wrap">Fungi Cultivation</span>
                            </mat-checkbox>
                            <mat-checkbox [checked]="license.psilocybinExtraction" disabled>
                              <span class="text-wrap">Psilocybin Extraction</span>
                            </mat-checkbox>
                            <mat-checkbox [checked]="license.ediblePsilocybinProduction" disabled>
                              <span class="text-wrap">Edible Psilocybin Production</span>
                            </mat-checkbox>

                            <mat-checkbox [checked]="license.denyEndorsementAttestation" disabled>
                              <span class="text-wrap">Applicant Attests to all endorsement statements</span>
                            </mat-checkbox>

                            <mat-checkbox *ngIf="license.ediblePsilocybinProduction" [checked]="license.edibleAttestation" disabled>
                              <span class="text-wrap">Applicant Attests to all edible endorsement statements</span>
                            </mat-checkbox>
                          </div>

                          <span class="f-s-16">
                            <strong>Financial Interest</strong>
                          </span>
                          <mat-checkbox [checked]="license.financialAttestation" disabled>
                            <span class="text-wrap">Applicant attests to all financial stuff</span>
                          </mat-checkbox>

                          <span class="f-s-16">
                            <strong>License Attestation</strong>
                          </span>
                          <mat-checkbox [checked]="license.attestation" disabled>
                            <span class="text-wrap">Applicant attests to everything</span>
                          </mat-checkbox>

                          <span class="f-s-16">
                            <strong>Registration Attestation</strong>
                          </span>
                          <mat-checkbox [checked]="license.registrationAttestation" disabled>
                            <span class="text-wrap">Applicant attests to registration requirements</span>
                          </mat-checkbox>

                          <span class="f-s-16">
                            <strong>Directory Consent</strong>
                          </span>
                          <mat-checkbox [checked]="license.directoryConsent" disabled>
                            <span class="text-wrap">
                              Applicant consents to having license in the OPS License Directory
                            </span>
                          </mat-checkbox>

                          <span class="f-s-16">
                            <strong>Electronic Signature</strong>
                          </span>
                          <span>{{license.electronicSignature}}</span>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card class="w-[50%]">
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <div class="flex flex-row w-[100%]">
                    <mat-card class="w-[100%]">
                      <mat-card-title>
                        <span>Manufacturer Address</span>
                      </mat-card-title>
                          <mat-card-content>
                            <div class="flex flex-col gap-4">
                              <span class="f-s-18"><strong>Physical Address</strong></span>
                              <div class="max-md:flex-col flex flex-row gap-2">
                                <span>{{license.physicalStreet}}</span>
                                <span>{{license.physicalCity}}</span>
                                <span>{{license.physicalState}}</span>
                                <span>{{license.physicalZip}}</span>
                                <span>{{license.physicalCounty}}</span>
                              </div>

                              <div class="flex flex-col">
                                <span><strong>Description of the premises</strong></span>
                                <div>
                                  <textarea matInput placeholder="Describe the Premises" cols="2" [value]="license.premisesDescription"></textarea>
                                </div>
                              </div>
                            </div>

                            <div class="m-t-8 flex flex-col">
                              <div class="max-md:flex-col flex flex-row gap-6">
                                <span class="f-s-18"><strong>Mailing Address</strong></span>
                                <mat-checkbox [checked]="license.mailingIsPhysical" disabled>
                                  Same as Physical
                                </mat-checkbox>
                              </div>
                              <div *ngIf="!license.mailingIsPhysical" class="max-md:flex-col flex flex-row gap-2">
                                <span>{{license.mailingStreet}}</span>
                                <span>{{license.mailingCity}}</span>
                                <span>{{license.mailingState}}</span>
                                <span>{{license.mailingZip}}</span>
                                <span>{{license.mailingCounty}}</span>
                              </div>
                            </div>
                          </mat-card-content>
                        </mat-card>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>

<!-- Applicants-->
              <div class="flex flex-row gap-4">
                <mat-card class="w-[100%]">
                  <mat-card-title>
                    <span>Applicants</span>
                  </mat-card-title>
                  <mat-card-content class="gap-[10px]">
                    <div class="flex flex-col gap-[18px]">
                      <div *ngFor="let applicant of license.applicants" class="flex flex-row w-[100%]">
                        <mat-card class="w-[100%]">
                         <div class="flex flex-col gap-2 w-[100%]">
                           <div class="flex flex-row gap-2">
                             <div class="flex flex-col w-[35%]">
                               <span><strong>Legal Name</strong></span>
                               <div class="flex flex-row gap-2">
                                 <span>{{applicant.legalFirstName}}</span>
                                 <span>{{applicant.legalMiddleName}}</span>
                                 <span>{{applicant.legalLastName}}</span>
                               </div>
                             </div>

                             <div class="flex flex-col w-[35%]">
                               <span><strong>Preferred Name</strong></span>
                               <div class="flex flex-row gap-2">
                                 <span>{{applicant.preferredFirstName}}</span>
                                 <span>{{applicant.preferredMiddleName}}</span>
                                 <span>{{applicant.preferredLastName}}</span>
                               </div>
                             </div>
                             <div class="flex flex-col w-[30%]">
                               <span><strong>Other Names or Aliases</strong></span>
                               <span>{{applicant.alternateNames}}</span>
                             </div>
                           </div>

                           <div class="flex flex-row gap-2 w-[100%]">
                            <div class="flex flex-col w-[25%]">
                              <span><strong>DOB</strong></span>
                              <div class="flex flex-row gap-2">
                                <span>{{applicant.dob | date}}</span>
                              </div>
                            </div>
                            <div class="flex flex-col gap-2 w-[75%]">
                              <span><strong>SSN</strong></span>
                              <div class="flex flex-row gap-2">
                                <span>{{applicant.ssn | mask:"000-00-0000"}}</span>

                                <mat-checkbox [checked]="applicant.noSSN" disabled>
                                  Applicant has no SSN
                                </mat-checkbox>
                                <mat-checkbox [checked]="applicant.ssnAttestation" disabled>
                                  <span class="text-wrap">
                                    Applicant consents to use of SSN
                                  </span>
                                </mat-checkbox>
                              </div>
                            </div>
                           </div>

                           <div flFlex="100" class="flex flex-row gap-2">
                             <div class="flex flex-col">
                               <span *ngIf="!applicant.heldLicense && !applicant.deniedLicense && !applicant.subjectToDiscipline && !applicant.suedForDamages && !applicant.settledAllegations && !applicant.allegedAbuse"> Applicant answered no to all additional questions. </span>
                               <mat-checkbox [checked]="applicant.heldLicense" disabled *ngIf="applicant.heldLicense">
                                 <span class="text-wrap">
                                   In the last 10 years, Applicant has held a license in Oregon or in another state or country.
                                 </span>
                               </mat-checkbox>
                               <mat-checkbox [checked]="applicant.deniedLicense" disabled *ngIf="applicant.deniedLicense">
                                 <span class="text-wrap">
                                   In the last 10 years, Applicant has been denied a license.
                                 </span>
                               </mat-checkbox>
                               <mat-checkbox [checked]="applicant.subjectToDiscipline" disabled *ngIf="applicant.subjectToDiscipline">
                                 <span class="text-wrap">
                                   In the last 10 years, Applicant has been subject to discipline by the entity that issued their license or had their license suspended or revoked.
                                 </span>
                               </mat-checkbox>
                               <mat-checkbox [checked]="applicant.suedForDamages" disabled *ngIf="applicant.suedForDamages">
                                 <span class="text-wrap">
                                   In the last 10 years, Applicant has been sued for money damages related to work they provided under a license.
                                 </span>
                               </mat-checkbox>
                               <mat-checkbox [checked]="applicant.settledAllegations" disabled *ngIf="applicant.settledAllegations">
                                 <span class="text-wrap">
                                   In the last 10 years, Applicant has settled allegations or claims against them related to a license.
                                 </span>
                               </mat-checkbox>
                               <mat-checkbox [checked]="applicant.allegedAbuse" disabled *ngIf="applicant.allegedAbuse">
                                 <span class="text-wrap">
                                   Applicant has had someone allege that they abused a child or an adult.
                                 </span>
                               </mat-checkbox>
                               <mat-checkbox [checked]="applicant.substantiatedAllegation" disabled *ngIf="applicant.substantiatedAllegation">
                                 <span class="text-wrap">
                                   Allegations were substantiated
                                 </span>
                               </mat-checkbox>
                             </div>
                           </div>

                           <div class="flex flex-row gap-2 w-[100%]">
                            <div class="max-lg:w-[100%] flex flex-col w-[50%]">
                              <span class="f-2-20"><strong>Primary Phone</strong></span>
                              <span>{{applicant.phone | mask:'(000)-000-0000 000000'}}</span>
                            </div>
                            <div class="max-lg:w-[100%] flex flex-col w-[50%]">
                              <span class="f-2-20"><strong>Alternate Phone</strong></span>
                              <span>{{applicant.alternatePhone | mask:'(000)-000-0000 000000'}}</span>
                            </div>
                            <div class="max-lg:w-[100%] flex flex-col w-[50%]">
                              <span class="f-2-20"><strong>Primary Email Address</strong></span>
                              <span>{{applicant.email}}</span>
                            </div>
                            <div class="max-lg:w-[100%] flex flex-col w-[50%]">
                              <span class="f-2-18"><strong>Preferred Language</strong></span>
                              <span>{{applicant.language}}</span>
                            </div>
                           </div>

                           <div class="flex flex-row gap-2 w-[100%]">
                            <div class="max-lg:w-[100%] flex flex-col w-[50%]">
                              <span class="f-2-20"><strong>Previous License or Permit</strong></span>
                              <mat-checkbox [checked]="applicant.previousLicense" disabled>
                                <span class="text-wrap">Applicant has other licenses</span>
                              </mat-checkbox>
                            </div>
                            <div class="max-lg:w-[100%] flex flex-col w-[50%]">
                              <span><strong>Other Oregon Psilocybin licenses</strong></span>
                              <span>{{applicant.affiliatedLicenses}}</span>
                            </div>
                           </div>

                           <div class="flex flex-row gap-2">
                             <div class="flex flex-col gap-2 w-[50%]">
                               <div class="flex flex-col">
                                 <span><strong>Physical Address</strong></span>
                                 <div class="max-md:flex-col flex flex-row gap-4">
                                   <span>{{applicant.physicalStreet }}</span>
                                   <span>{{applicant.physicalCity }}</span>
                                   <span>{{applicant.physicalState }}</span>
                                   <span>{{applicant.physicalZip }}</span>
                                   <span>{{applicant.physicalCounty }}</span>
                                 </div>
                               </div>

                               <div class="m-t-8 flex flex-col">
                                 <div class="max-md:flex-col flex flex-row justify-start items-center gap-6">
                                   <span><strong>Mailing Address</strong></span>
                                   <mat-checkbox [checked]="applicant.mailingIsPhysical" disabled>
                                     Same as physical
                                   </mat-checkbox>
                                 </div>
                                 <div [@slideInOut] *ngIf="!applicant.mailingIsPhysical" class="flex flex-col">
                                   <span>{{applicant.mailingStreet }}</span>
                                   <span>{{applicant.mailingCity }}</span>
                                   <span>{{applicant.mailingState }}</span>
                                   <span>{{applicant.mailingZip }}</span>
                                   <span>{{applicant.mailingCounty }}</span>
                                 </div>
                               </div>
                             </div>
                           </div>
                         </div>
                       </mat-card>
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>

<!-- Entity Applicants-->
              <div class="flex flex-row gap-4">
                <mat-card class="w-[100%]">
                  <mat-card-title>
                    <span>Entity Applicants</span>
                  </mat-card-title>
                  <mat-card-content class="gap-[10px]">
                    <div class="flex flex-col gap-[18px]">
                      <div *ngFor="let applicant of license.entityApplicants" class="flex flex-row w-[100%]">
                        <mat-card class="w-[100%]">
                          <div class="flex flex-col gap-2 w-[100%]">

                            <div class="flex flex-row gap-2">
                              <div class="flex flex-col w-[35%]">
                                <span><strong>Legal Entity Name</strong></span>
                                <div class="flex flex-row gap-2">
                                  <span>{{applicant.entityName}}</span>
                                </div>
                              </div>

                              <div class="flex flex-col w-[35%]">
                                <span><strong>Contact Phone</strong></span>
                                <div class="flex flex-row gap-2">
                                  <span>{{applicant.primaryContactNumber | mask:'(000)-000-0000 000000'}}</span>
                                </div>
                              </div>
                              <div class="flex flex-col w-[30%]">
                                <span><strong>Email Address</strong></span>
                                <span>{{applicant.primaryContactEmail}}</span>
                              </div>
                            </div>

                            <div class="flex flex-row gap-2 w-[100%]">
                              <div class="flex flex-col w-[25%]">
                                <span><strong>Preferred Language</strong></span>
                                <div class="flex flex-row gap-2">
                                  <span>{{applicant.language}}</span>
                                </div>
                              </div>
                              <div class="flex flex-col w-[25%]">
                                <span><strong>Previous License or Permit</strong></span>
                                  <mat-checkbox [checked]="applicant.previousLicense" disabled>
                                    <span class="text-wrap">
                                      Entity has applied for or received other licenses from Oregon Psilocybin Services
                                    </span>
                                  </mat-checkbox>
                              </div>
                              <div class="flex flex-col w-[25%]">
                                <span><strong>Oregon Psilocybin license Ids</strong></span>
                                <span>{{applicant.affiliatedLicenses}}</span>
                              </div>
                            </div>

                            <div class="flex flex-row gap-2 w-[100%]">
                              <div class="flex flex-col w-[50%]">
                                <span><strong>Registered Business</strong></span>
                                <div class="flex flex-row gap-2">
                                  <mat-checkbox [checked]="applicant.businessInOregon" disabled>
                                    <span class="text-wrap">This legal entity is registered as a business with the Secretary of State (SOS) in Oregon</span>
                                  </mat-checkbox>
                                </div>
                                <div class="flex flex-row gap-2">
                                  <mat-checkbox [checked]="applicant.registeredBusiness" disabled>
                                    <span class="text-wrap">This legal entity is registered as a business in another state, US territory or a freely associated state</span>
                                  </mat-checkbox>
                                </div>
                              </div>
                            </div>

                              <div class="flex flex-row gap-2 w-[100%]">
                                <div class="flex flex-col w-[25%]">
                                  <span><strong>Oregon Secretary of State Registry Number</strong></span>
                                  <div class="flex flex-row gap-2">
                                    <span>{{applicant.secretaryofStateNumber}}</span>
                                  </div>
                                </div>

                                <div class="flex flex-col w-[25%]">
                                  <span><strong>Location Registered</strong></span>
                                  <div class="flex flex-row gap-2">
                                    <span>{{applicant.registeredIn}}</span>
                                  </div>
                                </div>

                                <div class="flex flex-col w-[25%]">
                                  <span><strong>Registration Number</strong></span>
                                  <div class="flex flex-row gap-2">
                                    <span>{{applicant.registryNumber}}</span>
                                  </div>
                                </div>
                              </div>


                            <div class="flex flex-row gap-2">
                              <div class="flex flex-col gap-2 w-[50%]">
                              <div class="flex flex-col">
                                <span><strong>Physical Address</strong></span>
                                <div class="max-md:flex-col flex flex-row justify-start items-center gap-6">
                                  <mat-checkbox [checked]="applicant.physicalIsHeadquarters" disabled>
                                    Same as Headquarters
                                  </mat-checkbox>
                                </div>
                                <div *ngIf="!applicant.physicalIsHeadquarters" class="max-md:flex-col flex flex-row gap-4">
                                  <span>{{applicant.physicalStreet }}</span>
                                  <span>{{applicant.physicalCity }}</span>
                                  <span>{{applicant.physicalState }}</span>
                                  <span>{{applicant.physicalZip }}</span>
                                  <span>{{applicant.physicalCounty }}</span>
                                </div>
                              </div>

                              <div class="flex flex-col">
                                <span><strong>Mailing Address</strong></span>
                                <div class="max-md:flex-col flex flex-row justify-start items-center gap-6">
                                  <mat-checkbox [checked]="applicant.mailingIsPhysical" disabled>
                                    Same as Physical
                                  </mat-checkbox>
                                  <mat-checkbox [checked]="applicant.mailingIsHeadquarters" disabled>
                                    Same as Headquarters
                                  </mat-checkbox>
                                </div>
                                <div *ngIf="!applicant.mailingIsPhysical && !applicant.mailingIsHeadquarters" class="max-md:flex-col flex flex-row gap-4">
                                  <span>{{applicant.mailingStreet }}</span>
                                  <span>{{applicant.mailingCity }}</span>
                                  <span>{{applicant.mailingState }}</span>
                                  <span>{{applicant.mailingZip }}</span>
                                  <span>{{applicant.mailingCounty }}</span>
                                </div>
                              </div>

                              <div class="flex flex-col">
                                <span><strong>Headquarters Address</strong></span>
                                <div class="max-md:flex-col flex flex-row gap-4">
                                  <span>{{applicant.headquartersStreet }}</span>
                                  <span>{{applicant.headquartersCity }}</span>
                                  <span>{{applicant.headquartersState }}</span>
                                  <span>{{applicant.headquartersZip }}</span>
                                  <span>{{applicant.headquartersCounty }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </mat-card>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-card-content>
        </mat-card>
      <div class="flex flex-row">
        <span class="flex-1"></span>
        <img class="p-4" src="../../../../../assets/images/ORSeal1.png" alt="OHA Logo">
      </div>
    </div>
  </kendo-pdf-export>
</mat-dialog-content>








